'use client'

import { CheckedState } from '@radix-ui/react-checkbox'
import { Button, Popover, PopoverContent, PopoverTrigger } from '@repo/ui'
import { Checkbox, useTableState } from '@repo/ui/components'
import { ColumnDefTemplate, HeaderContext } from '@tanstack/react-table'
import { Columns3 } from 'lucide-react'
import React, { useState } from 'react'

export const TableSettings = <TData,>() => {
  const { table } = useTableState<TData>()

  const headers = table.getAllColumns() ?? []

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button className={'max-md:size-10'} variant={'outline'}>
          <Columns3 size={16} /> <span className={'max-md:hidden'}>Columns</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <div>
          <p className={'p-3 font-medium'}>Customize Columns</p>
        </div>
        <div>
          {headers.map(column => (
            <SettingsCheckbox
              checked={column.getIsVisible()}
              key={column.id}
              label={column.columnDef.header}
              onChange={column.toggleVisibility}
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}

const SettingsCheckbox = <T,>({
  label,
  onChange,
  ...props
}: {
  checked: boolean
  label: ColumnDefTemplate<HeaderContext<T, unknown>> | string | undefined
  onChange: (value: boolean) => void
}) => {
  const [checked, setChecked] = useState<CheckedState>(props.checked)

  return (
    <div
      className={
        'flex items-center gap-2 border-b border-[#F5F5F5] px-3 py-2 last:border-b-0 dark:text-[#b6c4d2]'
      }
    >
      <Checkbox
        checked={checked}
        id={label as string}
        onCheckedChange={event => {
          setChecked(event)
          if (typeof event === 'boolean') onChange(event)
        }}
      />
      <label htmlFor={label as string}>{label as string}</label>
    </div>
  )
}
